import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Plus, Trash, Check } from "@phosphor-icons/react";

export default function Todos() {
  const [todos, setTodos] = useState([]);
  const [text, setText] = useState("");

  const load = () => api.get("/todos").then((r) => setTodos(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try { await api.post("/todos", { text }); setText(""); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const toggle = async (id) => { await api.patch(`/todos/${id}`); load(); };
  const remove = async (id) => { await api.delete(`/todos/${id}`); load(); };

  return (
    <div className="space-y-10">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-sage font-bold mb-2">Daily tasks</p>
        <h1 className="font-serif text-4xl md:text-5xl font-medium">Small commitments. Steady becoming.</h1>
      </div>

      <form onSubmit={add} className="flex gap-3">
        <input value={text} onChange={(e) => setText(e.target.value)}
               placeholder="What needs gentle attention today?"
               data-testid="todo-input"
               className="flex-1 px-5 py-3 rounded-full border border-border bg-white focus:outline-none focus:ring-2 focus:ring-sage" />
        <button type="submit" data-testid="todo-add"
                className="px-5 py-3 rounded-full bg-moss text-white hover:bg-mossDark inline-flex items-center gap-2">
          <Plus size={16} /> Add
        </button>
      </form>

      <div className="space-y-2">
        {todos.length === 0 ? (
          <p className="text-muted-foreground">Nothing yet — add your first task above.</p>
        ) : todos.map((t) => (
          <div key={t.id} data-testid={`todo-${t.id}`}
               className="bg-white rounded-2xl border border-border p-4 flex items-center gap-4 soft-shadow">
            <button onClick={() => toggle(t.id)} data-testid={`todo-toggle-${t.id}`}
                    className={`w-7 h-7 rounded-full flex items-center justify-center transition-all ${
                      t.completed ? "bg-moss text-white" : "bg-cream hover:bg-sage/30"
                    }`}>
              {t.completed && <Check size={14} weight="bold" />}
            </button>
            <p className={`flex-1 ${t.completed ? "line-through text-muted-foreground" : ""}`}>{t.text}</p>
            <button onClick={() => remove(t.id)} data-testid={`todo-delete-${t.id}`}
                    className="text-muted-foreground hover:text-destructive">
              <Trash size={18} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
